import React, { DependencyList } from "react";

export function useOnceCallback<T extends (...args: any[]) => any>(callback: T, deps: DependencyList) {
    const onceRef = React.useRef(false);

    return React.useCallback(
        (...args: any[]) => {
            if (onceRef.current) return;

            onceRef.current = true;
            callback(...args);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [callback, ...deps]
    );
}
